// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10BVh","newExpiryDate":"styles_newExpiryDate__10PmI","footer":"styles_footer__3z5M8"};